// NGRX
import {createFeatureSelector} from '@ngrx/store';
import {createEntityAdapter, EntityAdapter, EntityState} from '@ngrx/entity';
// Actions
import {LeaderLevelActions, LeaderLevelActionTypes} from '../_actions/leader-level.actions';
// CRUD
import {QueryParamsModel} from '../../_base/crud';
// Models
import {LeaderLevelModel} from '../_models/leader-level.model';

export interface LeaderLevelsState extends EntityState<LeaderLevelModel> {
    listLoading: boolean;
    actionsloading: boolean;
    totalCount: number;
    lastQuery: QueryParamsModel;
    lastCreatedLeaderLevelId: number;
    showInitWaitingMessage: boolean;
}

export const adapter: EntityAdapter<LeaderLevelModel> = createEntityAdapter<LeaderLevelModel>();

export const initialLeaderLevelsState: LeaderLevelsState = adapter.getInitialState({
    listLoading: false,
    actionsloading: false,
    totalCount: 0,
    lastQuery: new QueryParamsModel({}),
    lastCreatedLeaderLevelId: undefined,
    showInitWaitingMessage: true
});

export function leaderLevelsReducer(state = initialLeaderLevelsState, action: LeaderLevelActions): LeaderLevelsState {
    switch (action.type) {
        case LeaderLevelActionTypes.LeaderLevelsPageToggleLoading:
            return {
                ...state, listLoading: action.payload.isLoading, lastCreatedLeaderLevelId: undefined
            };
        case LeaderLevelActionTypes.LeaderLevelsActionToggleLoading:
            return {
                ...state, actionsloading: action.payload.isLoading
            };
        case LeaderLevelActionTypes.LeaderLevelOnServerCreated:
            return {
                ...state
            };
        case LeaderLevelActionTypes.LeaderLevelCreated:
            return adapter.addOne(action.payload.leaderLevel, {
                ...state, lastCreatedLeaderLevelId: action.payload.leaderLevel.id
            });
        case LeaderLevelActionTypes.LeaderLevelUpdated:
            return adapter.updateOne(action.payload.partialLeaderLevel, state);
        case LeaderLevelActionTypes.OneLeaderLevelDeleted:
            return adapter.removeOne(action.payload.id, state);
        case LeaderLevelActionTypes.LeaderLevelsPageCancelled:
            return {
                ...state, listLoading: false, lastQuery: new QueryParamsModel({})
            };
        case LeaderLevelActionTypes.LeaderLevelsPageLoaded:
            return adapter.addMany(action.payload.leaderLevels, {
                ...initialLeaderLevelsState,
                totalCount: action.payload.totalCount,
                listLoading: false,
                lastQuery: action.payload.page,
                showInitWaitingMessage: false
            });
        default:
            return state;
    }
}

export const getLeaderLevelState = createFeatureSelector<LeaderLevelModel>('leaderLevels');

export const {
    selectAll,
    selectEntities,
    selectIds,
    selectTotal
} = adapter.getSelectors();
